// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"7363e580","952":"5bc4348d"}[chunkId] + ".chunk.js";
};